import { ArrowUp } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowUp12Line = createIcon(ArrowUp, 12, "Line");
export const IconArrowUp16Line = createIcon(ArrowUp, 16, "Line");
export const IconArrowUp20Line = createIcon(ArrowUp, 20, "Line");
export const IconArrowUp24Line = createIcon(ArrowUp, 24, "Line");
export const IconArrowUp32Line = createIcon(ArrowUp, 32, "Line");
export const IconArrowUp48Line = createIcon(ArrowUp, 48, "Line");
export const IconArrowUp64Line = createIcon(ArrowUp, 64, "Line");
